import { j as i } from "../../jsx-runtime.BREq8dyb.js";
import { useTheme as m, Drawer as u } from "@mui/material";
import { memo as l } from "react";
const p = l(({
  hideBackdrop: e = !0,
  anchor: r = "right",
  width: o = "sm",
  PaperProps: t = {},
  ModalProps: s = {},
  ...a
}) => {
  const {
    breakpoints: n
  } = m();
  return /* @__PURE__ */ i.jsx(u, { ModalProps: {
    // Using two Modals on the same page causes Max stack exceed issue
    // https://github.com/mui/material-ui/issues/8741
    // Disabling enforced focus on the Drawer Modal added to prevent this issue
    disableEnforceFocus: !0,
    disablePortal: !0,
    ...s,
    sx: {
      pointerEvents: e ? "none" : "auto",
      ...s.sx || {}
    }
  }, PaperProps: {
    ...t,
    sx: {
      pointerEvents: "auto",
      ...t.sx || {},
      width: n.values[o]
    }
  }, anchor: r, hideBackdrop: e, ...a });
});
p.displayName = "DqSidePanel";
export {
  p as default
};
//# sourceMappingURL=DqSidePanel.js.map
